import { Button } from "antd";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { generateToken } from "../../../firebase";
import { routePaths } from "../../../routing/routePaths";
import CardWrapper from "./CardWrapper";
import LanguageCard from "./LanguageCard";

const SelectLanguage = () => {
  const navigate = useNavigate();
  const selectedLang = Cookies.get("currentLanguage");
  const [currentLanguage, setCurrentLanguage] = useState(selectedLang || "en");

  const { i18n } = useTranslation();
  return (
    <CardWrapper>
      <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mx-auto select-language-details">
        <h1>Select Preferred Language</h1>
        <p>
          Select your preferred language to customize the app <br /> and enjoy a
          seamless experience.
        </p>
        <div className="row">
          <div className="col-12">
            <LanguageCard
              currentLanguage={currentLanguage}
              handleSetLanguage={(val) => setCurrentLanguage(val)}
            />
            <Button
              className="auth-theme-btn auth-theme-btn-fix"
              onClick={() => {
                generateToken();
                i18n.changeLanguage(currentLanguage);
                Cookies.set("currentLanguage", currentLanguage, {
                  expires: 30,
                });
                navigate(routePaths.login);
              }}
              disabled={!currentLanguage}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </CardWrapper>
  );
};

export default SelectLanguage;
